<!--
* @description  参数1
* @fileName  totalShipment
* @author userName
* @date 2024-01-08 09:56:30
!-->
<template>
  <div id="totalShipment" class="totalShipment">
    <div class="totalShipment-tip">
      <span> Calculating by total shipment is less accurate and therefore more likely to incur an additional
        charge for inaccurate or oversized dimensions.</span>
    </div>
    <div class="form-class main-info check-price-form">
      <el-form
        ref="formData"
        :model="formData"
        :rules="allRules"
        label-position="top"
        size="medium"
        class="item-Surcharge"
        @submit.native.prevent
      >
        <div class="form-item">
          <el-form-item class="flex-width_1" prop="quantity" label="# of units">
            <el-input-number
              v-model="formData.quantity"
              style="width: 186px"
              :min="1"
              :max="9999"
              label=""
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item class="flex-width_2" prop="volume" label="Total volume">
            <el-input
              v-model="formData.volume"
              v-inputNumber="{ type: 'float', number: 3 }"
              style="width: 236px"
              placeholder=""
              @focus="inputSelect($event)"
            >
              <template slot="append">
                <el-form-item prop="volumeUnit">
                  <el-select v-model="formData.volumeUnit" @change="volumeUnitChange">
                    <el-option
                      v-for="item in volumeUnitOptions"
                      :key="item.label"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="flex-width_2" prop="weight" label="Total weight">
            <el-input
              v-model="formData.weight"
              v-inputNumber="{ type: 'float', number: 3 }"
              style="width: 236px"
              placeholder=""
              @focus="inputSelect($event)"
            >
              <template slot="append">
                <el-form-item prop="weightUnit">
                  <el-select v-model="formData.weightUnit">
                    <el-option
                      v-for="item in weightUnitOptions"
                      :key="item.label"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="foot-button">
      <button type="button" :class="[{'confirm-button-ok':isAllOk}]" @click.stop="confirm">Confirm</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalShipment',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      formData: {
        quantity: '',
        volume: '',
        weight: '',
        volumeUnit: 'CBM',
        weightUnit: 'KG'
      },
      volumeUnitOptions: [{
        value: 'CBM',
        label: 'CBM'
      },
      {
        value: 'CFT',
        label: 'CFT'
      }
      ],
      weightUnitOptions: [{
        value: 'KG',
        label: 'KG'
      },
      {
        value: 'LB',
        label: 'LB'
      }
      ],
      allRules: {
        quantity: [{
          required: true,
          trigger: 'blur',
          message: 'required'
        }],
        volume: [{
          required: true,
          trigger: 'blur',
          message: 'required'
        }],
        weight: [{
          required: true,
          trigger: 'blur',
          message: 'required'
        }]
      }
    }
  },
  computed: {
    // 计算属性
    isAllOk() {
      return this.formData.quantity && this.formData.volume && this.formData.weight
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.formData = data
    },
    volumeUnitChange(val) {
      if (val === 'CBM') {
        this.formData.weightUnit = 'KG'
      } else {
        this.formData.weightUnit = 'LB'
      }
    },
    // 方法
    handleChange(value) {
      console.log(value)
    },
    inputSelect(e) {
      e.target.select()
    },
    confirm() {
      this.$refs.formData.validate(valid => {
        var totalInfo = {
          weight: 0,
          volume: 0,
          quantity: 0
        }
        totalInfo.weight = this.formData.weight
        if (this.formData.weightUnit === 'LB') {
          totalInfo.weight = (this.formData.weightUnit * 0.4535924).toFixed(2)
        }
        totalInfo.volume = this.formData.volume
        if (this.formData.volumeUnit === 'CFT') {
          totalInfo.volume = (this.formData.volume * 0.0283168).toFixed(2)
        }
        totalInfo.quantity = this.formData.quantity
        this.$emit('next', totalInfo, this.formData)
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.totalShipment {
		margin: 8px 16px 16px;

		.totalShipment-tip {
			width: 692px;
			height: 52px;
			background: rgba(2, 127, 252, 0.04);
			border-radius: 4px;
			text-align: left;

			span {
				display: flex;
				margin-left: 8px;
				padding-top: 8px;
			}
		}

		.form-item {
			display: flex;

			::v-deep .el-form-item {
				margin-bottom: 0;

				.el-form-item__label {
					float: left;
					padding: 0;
					margin-top: 4px;
				}

				.el-input__inner {
					height: 40px !important;
				}

				.el-form-item__content {
					.el-input-number {
						// span {
						// 	height: 38px;
						// }
					}
				}

				.el-input-number {

					.el-input-number__decrease,
					.el-input-number__increase {
						width: 24px;
						height: 24px;
						background: rgba(170, 170, 170, 0.16);
						border-radius: 4px;
						margin: 8px;
						border: 0px;
						display: flex;
						align-items: center;
						justify-content: center;

						i {
							font-weight: bold !important;
							color: #272636 !important;

						}
					}

				}
			}

			.flex-width_1,
			.flex-width_2,
			.flex-width_3 {
				margin-right: 16px;
			}

			::v-deep .flex-width_2 {
				.el-form-item__content {
					.el-input {
						.el-input-group__append {
							width: 80px;
						}
					}
				}
			}
		}

		.foot-button {
			text-align: right;
			margin: 24px 16px 16px;

			.confirm-button-ok {
				background: #E95506 !important;
			}

			button {
				width: 108px;
				height: 40px;
				background: #F5B492;
				border-radius: 8px;
				font-size: 16px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #FFFFFF;
				line-height: 35px;
				border: 0;

				&:hover {
					background: #E95506 !important;
				}

				&:active {
					background: #E95506 !important;
				}
			}
		}
	}
</style>
